import React from 'react'
import Modal from '@material-ui/core/Modal'
import styles from './styles.module.css'
import TextField from '@material-ui/core/TextField'
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import IconButton from '@material-ui/core/IconButton' 
import axios from 'axios'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import Dialog from '@material-ui/core/Dialog';
import {connect} from 'react-redux'; 
import InputAdornment from '@material-ui/core/InputAdornment'

const ConfTax = (props) => {
    const [formData,setFormData] = React.useState({
        taxId: "",
        gst: "",
        name: "",
        userId: props.user._id,
    }); 

    const [loading,setLoading] = React.useState(false) 
    const [err,setErr] = React.useState({gst: false,name: false})

    React.useEffect(() => {
        if(props.type == "EDIT") { 
            setFormData({...formData,...props.tax,taxId: props.tax._id})
        } 
    },[props.tax]); 
    
    const validate = () => {
        let validData = true;
        
        let error = {gst: false,name: false}
        setErr({...err,...error});
        Object.keys(error).map(key => {
            if(formData[key] == "") {
                error[key] = "Field cannot be empty";
                validData = false
            } 
        })
        setErr({...error});

        return validData;
    }
    // SUBMIT
    const onSubmit = () => {
        if(validate()) {
            setLoading(true);
            const url = props.type == "EDIT" ? "/editTax" : "/addTax"

            axios({
                method: "post",
                url: url,
                data: {
                    ...formData, 
                }
            })
            .then(res => {
                if(res.data.success) {
                    props.onDone()
                    setLoading(false);
                    props.setAlert("Succesfully Done")
                    setFormData({taxId: "",gst: "",name: "",userId: props.user._id,})
                } else {
                    setLoading(false);
                    props.setAlert("Something went wrong !Try Again")
                }
            }).catch(err => {
                console.log(err)
                setLoading(false)
                props.setAlert("Something went wrong !Try Again")
            })
        }
    }

    let btnText = props.type == "EDIT" ? "Update Tax" : "Add Tax";
    return (  
        <Dialog open={props.open} onClose={props.onClose} scroll={'paper'} maxWidth={'md'} fullWidth={true}>
            <div className={styles.container}>
                <div className={styles.containerContent}>
                    
                    <div className={styles.header}>
                        <h1>{btnText}</h1>
                        <IconButton onClick={props.onClose}>
                            <CloseRoundedIcon   />
                        </IconButton>
                    </div>

                    <h2>Details</h2>

                    <div className={styles.content}>
                        <div className={styles.row}>
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Name"
                                value={formData.name}
                                onBlur={(e) => setFormData({...formData,name: e.target.value.trim()})}

                                onChange={(e) => setFormData({...formData,name: e.target.value})}
                                error={err.name}
                                helperText={err.name}
                            />

                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="GST"
                                value={formData.gst}
                                type="number"
                                onBlur={(e) => setFormData({...formData,gst: e.target.value.replace(/\D/,'').trim()})}

                                onChange={(e) => {
                                    e.target.value <= 100 && setFormData({...formData,gst: e.target.value.replace(/\D/,'')})
                                }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                }}
                                error={err.gst}
                                helperText={err.gst}
                            /> 
                        </div>  

                    </div>

                    <Divider />
 
                     
                    <div className={styles.footer}>
                        {loading 
                            ?
                        <Button variant="contained" color="secondary">
                            Loading....
                        </Button>
                            :
                        <Button variant="contained" color="secondary" onClick={onSubmit}>
                            {btnText}
                        </Button>}
                    </div>
                </div>
            </div>
        </Dialog>  
    )
}

const mapStateToProps = state => ({
    user: state.appReducer.user
})
export default connect(mapStateToProps)(ConfTax);